import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledHeader = styled.header`
  p,
  span {
    font-size: 14px;
  }
`;

export const HeaderInfo = styled.div`
  margin-top: 15px;
  padding: 0 10px;
  display: flex;
  justify-content: start;

  div {
    display: flex;
    span {
      font-weight: bold;
      margin-right: 4px;
      padding: 0 3px 0 8px;
    }
  }
`;

export const AudioRow = styled.div`
  margin-top: 26px;
  display: flex;
  align-items: center;

  audio {
    width: 100%;
  }

  div {
    display: flex;
    button {
      margin-right: 10px;
    }
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  margin: 0 5px;
`;
